import { Theme, css } from '@emotion/react';

export const rowLayoutWidgetContainer = ({ spacing, breakpoints }: Theme) => css`
  display: flex;
  flex-direction: column;

  & > * + * {
    margin-left: 0;
    margin-top: ${spacing(2.5)}px;
  }

  ${breakpoints.up('md')} {
    flex-direction: row;

    & > * + * {
      margin-top: 0;
      margin-left: ${spacing(3)}px;
    }
  }
`;

export const rowLayoutWidgetItem = (widthPercentage: number) => css`
  display: flex;
  flex-direction: column;
  flex: 1 1 ${widthPercentage}%;

  & > * {
    flex: 1;
  }
`;
